import { put, takeLatest, select, call } from 'redux-saga/effects';

import { ACCOUNT_DATA_TERMINATE_LOADING } from '../../SFAccountService/actions';
import { OPPORTUNITY_DATA_TERMINATE_LOADING } from '../../SFOpportunityService/actions';
import { SHIPPING_ADDRESS_DATA_TERMINATE_LOADING } from '../../SFShippingAddressService/actions';
import { QUOTATION_DATA_TERMINATE_LOADING } from '../../SFQuotationService/actions';

import { CUSTOMER_INFORMATIONS_READY } from '../CustomerInformationService/actions';
import { CUSTOMER_ADDRESS_READY } from '../CustomerAddressService/actions';
import { CUSTOMER_DETAILS_READY } from '../CustomerDetailsService/actions';

import accountApi from '../../../api/account';
import opportunityApi from '../../../api/opportunity';
import shippingAddressApi from '../../../api/shippingAddress';

import * as Actions from './actions';

export function* notify(action) {
  const account = action.hasOwnProperty('account')
    ? action.account
    : yield select(state => state.account);
  const opportunity = action.hasOwnProperty('opportunity')
    ? action.opportunity
    : yield select(state => state.opportunity);
  const shippingAddress = action.hasOwnProperty('shippingAddress')
    ? action.shippingAddress
    : yield select(state => state.shippingAddress);
  const quotation = action.hasOwnProperty('quotation')
    ? action.quotation
    : yield select(state => state.quotation);
  yield put(Actions.SfDataReady(account, opportunity, shippingAddress, quotation));
}

export function* notifySF(action) {
  const customerInformations = action.hasOwnProperty('informations')
    ? action.informations
    : yield select(state => state.customerInformations);
  const customerAddress = action.hasOwnProperty('address')
    ? action.address
    : yield select(state => state.customerAddress);
  const customerDetails = action.hasOwnProperty('details')
    ? action.details
    : yield select(state => state.customerDetails);
  yield put(Actions.frontInformationsReady(customerInformations, customerAddress, customerDetails));
}

export function* sendBackToSalesforce(action) {
  const account = yield select(state => state.account);
  const shippingAddress = yield select(state => state.shippingAddress);
  yield call(accountApi.updateAccount, account.getId(), account);
  yield call(shippingAddressApi.updateShippingAddress, shippingAddress.getId(), shippingAddress);
}

export function* updateOpportunityIfNeeded(action) {
  let opportunity = yield select(state => state.opportunity);
  if (opportunity) {
    opportunity = opportunity.clone().setStageValue(action.stageValue);
    yield call(opportunityApi.updateOpportunity, opportunity.getId(), opportunity);
    yield put(Actions.updateOpportunityStorage(opportunity));
  }
}

export function* sfDataListener() {
  yield takeLatest(
    [
      ACCOUNT_DATA_TERMINATE_LOADING,
      OPPORTUNITY_DATA_TERMINATE_LOADING,
      SHIPPING_ADDRESS_DATA_TERMINATE_LOADING,
      QUOTATION_DATA_TERMINATE_LOADING,
    ],
    notify,
  );
  yield takeLatest(
    [CUSTOMER_INFORMATIONS_READY, CUSTOMER_ADDRESS_READY, CUSTOMER_DETAILS_READY],
    notifySF,
  );
  yield takeLatest(Actions.SEND_BACK_DATA_TO_SALESFORCE, sendBackToSalesforce);
  yield takeLatest(Actions.OPPORTUNITY_NEED_UPDATE, updateOpportunityIfNeeded);
}



// WEBPACK FOOTER //
// ./src/services/DataServices/SFDataService/saga.js